import { BaseEntity } from '../../xform-compat';
import { RmsUser } from './rms-user';

export enum DomainRelevance {
  DEFAULT = 'DEFAULT',
  COMPANY = 'COMPANY',
}

export class Domain implements BaseEntity {
  id: number;
  created: string;
  updated: string;
  createdBy: RmsUser;
  active: boolean;
  name: string;
  shortName: string;
  usersCount: number;
  relevance: DomainRelevance;
  users: Array<RmsUser>;
  userIds?: Array<number>;
  leaderIds?: Array<number>;

  constructor (domain: any = {}) {
    this.id = domain.id || null;
    this.name = domain.name || null;
    this.shortName = domain.shortName || null;
    this.userIds = domain.userIds || [];
    this.users = domain.users || [];
  }
}
